import type { SvgIconProps } from "@mui/material"
import AccountTreeRoundedIcon from "@mui/icons-material/AccountTreeRounded"
import CloudRoundedIcon from "@mui/icons-material/CloudRounded"
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded"
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded"
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded"
import KeyRoundedIcon from "@mui/icons-material/KeyRounded"
import LockRoundedIcon from "@mui/icons-material/LockRounded"
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded"
import PersonRoundedIcon from "@mui/icons-material/PersonRounded"
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded"
import TuneRoundedIcon from "@mui/icons-material/TuneRounded"
import DeviceIcon from "icons/DeviceIcon"
import SegmentIcon from "icons/SegmentIcon"
import SpanIcon from "icons/SpanIcon"
import TowerIcon from "icons/TowerIcon"

const iconProps: SvgIconProps = { fontSize: "small" }
const customIconStyle = { marginRight: "0.35rem", flexShrink: 0 }

export const TAB_ICONS: Record<string, React.ReactElement> = {
  "account_settings.GENERAL": <PersonRoundedIcon {...iconProps} />,
  "account_settings.SECURITY": <LockRoundedIcon {...iconProps} />,
  "tabs.ACTIVITY": <HistoryRoundedIcon {...iconProps} />,
  "tabs.ALERTS": <NotificationsRoundedIcon {...iconProps} />,
  "tabs.AMBIENT": <CloudRoundedIcon {...iconProps} />,
  "tabs.ASSETS": <AccountTreeRoundedIcon {...iconProps} />,
  "tabs.CONFIGURED_ALERTS": <TuneRoundedIcon {...iconProps} />,
  "tabs.DEVICE": (
    <DeviceIcon color="currentColor" width={18} height={18} style={customIconStyle} />
  ),
  "tabs.DEVICES": <AccountTreeRoundedIcon {...iconProps} />,
  "tabs.DOCUMENTATION": <DescriptionRoundedIcon {...iconProps} />,
  "tabs.GLOBAL": (
    <TowerIcon color="currentColor" width={18} height={18} style={customIconStyle} />
  ),
  "tabs.OVERVIEW": <BarChartRoundedIcon {...iconProps} />,
  "tabs.SEGMENTS": (
    <SegmentIcon color="currentColor" width={18} height={18} style={customIconStyle} />
  ),
  "tabs.SETTINGS": <SettingsRoundedIcon {...iconProps} />,
  "tabs.SPAN": (
    <SpanIcon
      color="currentColor"
      width={23}
      height={25}
      style={{ ...customIconStyle, marginRight: "0.5rem" }}
    />
  ),
  "tabs.TOKEN": <KeyRoundedIcon {...iconProps} />,
  "tabs.TOWER": (
    <TowerIcon color="currentColor" width={18} height={18} style={customIconStyle} />
  ),
  "tabs.TOWER_HEALTH": (
    <TowerIcon color="currentColor" width={18} height={18} style={customIconStyle} />
  ),
}
